module.exports = __webpack_public_path__ + "img/main-bg-mobile.144bd4fc.webp";